// extracted by mini-css-extract-plugin
module.exports = {"content":"News_content__2b-5H","news":"News_news__1sfSd","item":"News_item__1n5Fx"};